export const actionTypes = {
    SESSION_START: 'session_start',
    BROADCAST_STARTED: 'estee_stage_broadcast',
};
